import React, { FC } from 'react';

import { Icon } from '@column/column-ui-kit';
import { Badge } from '@column/ui';

import { getTransferBadgeClassName } from '~/lib/transfers/utils';
import { getStatementPeriod } from '~/util/reporting';

export const StatementPeriod: FC<{ type?: string; toDate?: string }> = ({ type, toDate }) => {
  const period = getStatementPeriod(type, toDate);
  if (!period) return null;

  return (
    <Badge variant="ghost" className={getTransferBadgeClassName()}>
      <span className="relative shrink-0 [&_.icon-calendar-line]:hidden">
        <span className="absolute inset-0 top-px flex items-center justify-center text-[7px] font-semibold leading-none">
          {period.calendarNumber}
        </span>
        <Icon.Calendar className="[--icon-size-x:16px] [--icon-size-y:16px]" />
      </span>
      {period.label}
    </Badge>
  );
};
